var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{ref:_vm.fieldData.model,attrs:{"value":_vm.inputModel,"label":_vm.fieldData.label,"required":_vm.fieldData.required},on:{"input":_vm.emitInput}})}
var staticRenderFns = []

export { render, staticRenderFns }